import { render, staticRenderFns } from "./TemplateDocumentosEditor.vue?vue&type=template&id=1dc58a82&scoped=true&"
import script from "./TemplateDocumentosEditor.vue?vue&type=script&lang=js&"
export * from "./TemplateDocumentosEditor.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDocumentosEditor.vue?vue&type=style&index=0&id=1dc58a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc58a82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
